import { Button } from "@rosc/ui/v32/button";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { PracticeBadge } from "./PracticeVisit";

// Above a practice consulta's note: what it is, and the guided steps again
// once they were closed.
export const PracticeNoteBanner = ({
  onRestartTour,
}: {
  /** Shown once the tour was finished or skipped. */
  onRestartTour?: () => void;
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div
      className="flex flex-col gap-2 rounded-[14px] bg-v3-brand-tint px-4 py-3 font-v3 sm:flex-row sm:items-center"
      data-testid="practice-banner"
      role="status"
    >
      <div className="flex min-w-0 flex-1 items-start gap-2.5">
        <PracticeBadge className="mt-px shrink-0 bg-v3-panel" />
        <p className="pt-0.5 text-[13.5px] leading-[1.45] text-v3-text">
          {t("guided.practice.noteBanner")}
        </p>
      </div>
      {onRestartTour && (
        <Button
          className="self-start sm:self-auto"
          data-testid="practice-restart-tour"
          variant="ghost"
          onClick={onRestartTour}
        >
          {t("guided.coach.restart")}
        </Button>
      )}
    </div>
  );
};
